import React from 'react';
import BaseNewCardView from '../../Cards/views/BaseNewCardView';
import QuickCashModel from '../models/quickCash.m';
import {apiback} from '../../../config';
import {canUseDOM} from './../../../helpers/canUseDOM';

export default class BaseQuickCashView extends BaseNewCardView {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            selectedType: 'loyal',
            isUtm: canUseDOM
                ? new URLSearchParams(this.props.location.search).get('utm_source')
                : ''
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.utmParams = this.saveUTMParams();
        document.addEventListener('switchCalcMode', this.setupCalcType);
        fetch(apiback('QUICK_CASH'))
            .then(response => response.json())
            .then(json =>
                this.setState({
                    model: new QuickCashModel(json.data, this.state.selectedType)
                })
            )
            .finally(() => this.onModelLoaded());
    }

    onModelLoaded() {}

    componentWillUnmount() {
        super.componentWillUnmount();
        document.removeEventListener('switchCalcMode', this.setupCalcType);
    }

    toggleModal(setLoanValues = true) {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            ...(setLoanValues && {
                loanSum: this.getModel().getCreditSum(),
                loanTerm: this.getModel().getCreditTerm()
            }),
            ...(prevState.showModal === true && {
                loanSum: null,
                loanTerm: null
            })
        }));
    }

    setupCalcType = e => {
        const model = this.state.model,
            mode = e.detail.mode;

        model.switchType(mode);
        this.setState({selectedType: mode});
    };
}
